export default "__VITE_ASSET__DCZDR6h7__"